import { MapTo } from '@adobe/cq-react-editable-components';
import Loadable from '../../../../utils/loadable';

const secureAccountPin = Loadable(() => import('../../containers/web/secureAccountPin'));
export default MapTo('vcg/components/soe-home/react/secureAccountPin')(secureAccountPin);
